import React, { useEffect, useState } from 'react'
import { Link, useLocation, useRouteMatch,useHistory } from 'react-router-dom'

import ConsultationDetails from '../ConsultationDetails/ConsultationDetails'
import '../../../../../../styles/common.css'
import { modalNames } from '../../../../../../constants/const'
import { useDispatch, useSelector } from 'react-redux'
import { logoutAction } from './../../../../../../actions/LoginAction'
import { getpatientconsultationhistory,fetchSelectedAppointmentDetails } from './../../../../../../actions/RPMAction'
import { INTERBRANCH_MODAL ,CLEAR_RPM_ADMIN ,CLEAR_RPM_PATIENT_VITALS} from '../../../../../../actions/type'

function ConsultationHistory() {

     const { rpmAppointmentHistoryModal } = useSelector((state) => state.modalRedux)
    
    let dispatch=useDispatch()
    const location = useLocation();  
    let reduxData = useSelector(state => state) ;
   
    let [appointmenthistorys, setAppointmenthistorys] = useState([])

    //let patientId = "";//**** IMPORTANT: Pass the patient Id */
    let nurseId = "";//**** IMPORTANT: Pass the nurse Id*/
    const patientId=localStorage.getItem('patientId') 
   // let consultationhistory = reduxData.rpmreducer.consultationhistory.data.appointmentHistory;
    let [modal, setModal] = useState(false)
    let [loaded, setloaded] = useState(false)
    let history = useHistory();

    //let consultationhistory=[]
    let consultationhistory = useSelector(state => state.rpmreducer?.consultationhistory?.data?.appointmentHistory)
  
    
    //let selectedAppointmentHistoryRedux = useSelector(state => state.appointmentHistory.appointmentHistory)

 
    useEffect(() => {
        dispatch(getpatientconsultationhistory(
            patientId)
        ).then((res)=>{

            if(res.data.title!=undefined && res.data.title==="Forbidden")
            {

                dispatch(logoutAction(userData, history)).then((res) => {
                    if (res) {
                        dispatch({ type: CLEAR_RPM_ADMIN });
                        history.push({
                            pathname:"/sessionExpired",
                          
                          });
                    }
                });

               
            }
            console.log("getpatientconsultationhistory",res)

        })
        loadConsultationHistory()
    }, [])
    
    


    const userData = useSelector(
        (state) => state.login.user
    );

    const patientData = useSelector(
        (state) => state.login.patientDashboard
    );


    let loadConsultations=()=>{
        setloaded(true)
        console.log("dispatch")
        dispatch(getpatientconsultationhistory(
            patientId)
          ).then((res)=>{

            setAppointmenthistorys(res.data)

        })
 
    }

   

    let moreButtonOnClick=(appointmentId)=>{

        console.log("moreButtonOnClick",appointmentId)
        /* dispatch(fetchSelectedAppointmentDetails({
            appointmentId: appointmentId ? appointmentId : null,
            userData
        })).then((res)=>{

            console.log("res",res)
            if(res.title!=undefined && res.title==="Forbidden")
            {

                dispatch(logoutAction(userData, history)).then((res) => {
                    if (res) {
                        dispatch({ type: CLEAR_RPM_ADMIN });
                        history.push({
                            pathname:"/sessionExpired",
                          
                          });
                    }
                });

               
            }

        }); */
         dispatch({
            type:INTERBRANCH_MODAL,
            payload:{
                name:modalNames.RPM_APPOINTMENT_HISTORY_MODAL,
                value:appointmentId
            }
        }) 
    }


    let loadConsultationHistory = () =>{

      //  console.log(consultationhistory);
    }

    console.log(consultationhistory);

    return (

        <div className='c2md-table-container'>


            <table className='c2md-table'>
                <tr>
                    <th>Mode</th>
                    <th>Doctor Name</th>
                    <th>Complaint</th>
                    <th>Consulted On</th>
                    <th>Action</th>
                    <th></th>
                </tr>

                <tbody>
                    {
                        //loaded?

                        consultationhistory&&consultationhistory.length>0 ?
                        consultationhistory.map((element,key)=>{
                       
                        return(
                            
                            <tr>
                                <td>Video</td>
                                <td>{element.doctorName}</td>
                                <td>{element.reasonForVisit?element.reasonForVisit:"NA"}</td>
                                <td>{element.appointmentDate}</td>
                                <td>{element.action?element.action:"NA"}</td>
                                <td style={{textAlign:"right"}}>
                                    <button onClick={()=>{moreButtonOnClick(element.appointmentId)}} className='more-btn'>More</button>
                                </td>
                            </tr>
                        )
                       })
                       : <tr>
                       <td colSpan={6}>

                           <div className="no-data">

                               {/* <img src={require('../../../../../../assets/RpmAssets/PNGIcons/more.png')} alt="" /> */}

                               <span>No data available</span>

                           </div>

                       </td>
                   </tr>
                   //:""
                    }
                </tbody>






            </table>




        </div>
        // <div className='consultation-history-container '>

        //     {
        //         selectedConsultation ?
        //             <ConsultationDetails />
        //             :
        //             <div className='consultation-history_table_container'>


        //                 <table className='appoinment-table'>
        //                     <tr>
        //                         <th>Mode</th>
        //                         <th>Doctor Name</th>
        //                         <th>Complaint</th>
        //                         <th>Consulted On</th>

        //                         <th>Action</th>
        //                         <th></th>
        //                     </tr>

        //                     <tbody>

        //                         {
        //                             ["", "", "", "",].map((element, key) => {
        //                                 return (

        //                                     <tr key={key}>
        //                                         <td>Video</td>
        //                                         <td>Dr Mohammed</td>
        //                                         <td>Low BP</td>
        //                                         <td>27, December, 2021</td>
        //                                         <td>Consulted via Video Call</td>
        //                                         <td><button className='more-btn' >More</button></td>
        //                                     </tr>
        //                                 )
        //                             })
        //                         }


        //                     </tbody>


        //                 </table>



        //             </div>

        //     }






        //     {/* <div className="pagination-container-mis-report">

        //         &nbsp;
        //         <Pagination
        //             showSizeChanger={false}
        //             pageSize={8}
        //             onChange={handlePaginationChange}
        //             defaultCurrent={1}
        //             total={misReportsPageLength ? misReportsPageLength * 8 : 0} />
        //     </div> */}



        // </div>
    )
}

export default ConsultationHistory